import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CREATE_SHIPMENT_REQUEST = NS + 'CREATE_SHIPMENT_REQUEST'
export const CREATE_SHIPMENT_SUCCESS = NS + 'CREATE_SHIPMENT_SUCCESS'
export const CREATE_SHIPMENT_ERROR = NS + 'CREATE_SHIPMENT_ERROR'

export const TOGGLE_SHIPMENT_TRACKING = NS + 'TOGGLE_SHIPMENT_TRACKING'



// WEBPACK FOOTER //
// ./src/modules/logistic/state/list/type.js